export function toUTCDateString(date) {
  return new Date(
    Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()),
  )
    .toISOString()
    .slice(0, 10);
}

export function createDefaultDateRange(monthsBack = 1) {
  const to = new Date();
  const from = new Date();
  from.setMonth(from.getMonth() - monthsBack);

  return {
    from: toUTCDateString(from),
    to: toUTCDateString(to),
  };
}

export function fromDateInputValue(value) {
  if (!value) return null;
  const [year, month, day] = String(value).split("-").map(Number);
  if (!year || !month || !day) return null;
  return new Date(year, month - 1, day);
}

export function toDateInputValue(date) {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function toPickerRange(range) {
  if (!range) return [null, null];
  return [fromDateInputValue(range.from), fromDateInputValue(range.to)];
}

export function fromPickerRange(range, fallbackRange = null) {
  if (!Array.isArray(range) || !range[0] || !range[1]) {
    return fallbackRange;
  }

  return {
    from: toDateInputValue(range[0]),
    to: toDateInputValue(range[1]),
  };
}
